import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NetworkStatusService } from './network-status.service';
import { first, ignoreElements } from 'rxjs/operators';
import { concat } from 'rxjs';
@Injectable()
export class OfflineInterceptor implements HttpInterceptor {
    constructor (private networkStatusService: NetworkStatusService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes("web-events")) {
            return next.handle(req);
        }
        return next.handle(req).pipe(
            catchError(err => {
                // At this point, we must return an observable.
                return concat(
                    // We're first waiting for the connection to become available.
                    // `ignoreElements` - will ignore `next` notifications. But it will let `error/complelete`
                    // notifications pass through.
                    this.networkStatusService.isOnline$.pipe(first(), ignoreElements()),
                    // After we're back online, we make the request once again.
                    next.handle(req),
                )
            })
        );
    }
}